import CampaignCustomFieldModelBase from '../_generated/modelBases/campaign-custom-field-model-base';

export default class CampaignCustomFieldModel extends CampaignCustomFieldModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
